import type { SelectProps } from "antd"
import type React from "react"

export type OmittedValues = Parameters<
  Extract<SelectProps["maxTagPlaceholder"], (...args: never[]) => unknown>
>[0]

/**
 * `maxTagCount="responsive"` measures the control and collapses whatever does
 * not fit into a counter tag. The counter is rendered before the measurement
 * settles — and again whenever the control reports no usable width — so a select
 * holding a single value shows a "+ 0 ..." chip in place of that value. Nothing
 * is omitted at zero, so nothing is announced.
 */
const hideEmptyOverflow = (omittedValues: OmittedValues): React.ReactNode =>
  omittedValues?.length ? `+ ${omittedValues.length} ...` : null

export { hideEmptyOverflow }
